var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3944",
    d: "M7 15c-.552 0-1-.45-1-1H5c0 1.102.898 2 2 2 1.103 0 2-.898 2-2H8c0 .55-.448 1-1 1Zm6.543-4.537c-.874-.832-1.542-1.703-1.542-4.654 0-2.487-1.98-4.515-4.501-4.76V.5a.5.5 0 1 0-1 0v.549c-2.52.245-4.501 2.273-4.501 4.76 0 2.951-.669 3.822-1.542 4.654a1.455 1.455 0 0 0-.352 1.6C.333 12.634.88 13 1.5 13h11c.62 0 1.168-.368 1.395-.937a1.454 1.454 0 0 0-.352-1.6ZM12.5 12h-11c-.445 0-.667-.515-.354-.813C2.236 10.15 3 8.99 3 5.81 2.999 3.704 4.789 2 7 2c2.211 0 4.001 1.704 4.001 3.81 0 3.167.757 4.334 1.853 5.377.314.3.089.813-.354.813Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.9f016d7739a3f40100e67ed69d05696a.svg";
export { ForwardRef as ReactComponent };